import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"
import { BADGE_DOT, BADGE_STATUS_VARIANTS } from "./controlStyles"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-white hover:bg-primary/90",
        secondary:
          "border-transparent bg-primary text-white hover:bg-primary/90",
        destructive:
          "border-transparent bg-destructive text-white hover:bg-destructive/90",
        outline: "border-primary bg-primary text-white hover:bg-primary/90",
        ...BADGE_STATUS_VARIANTS,
      },
      dot: {
        true: `gap-1.5 ${BADGE_DOT}`,
        false: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, dot, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, dot }), className)} {...props} />
  )
}

export { Badge, badgeVariants }